/// <amd-module name="SuiteCommerce.PhotoGallery.Main"/>
define("SuiteCommerce.PhotoGallery.Main", ["require", "exports", "SuiteCommerce.PhotoGallery"], function (require, exports, PhotoGalleryModuleCCT) {
    "use strict";
    return {
        mountToApp: function (container) {
            PhotoGalleryModuleCCT.mountToApp(container);
        },
    };
});
